import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { DirectoryHelperState } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-helper/directory-helper.state';
import { DirectoryStructureSelectors } from 'src/app/store/samwin/directory/directory-structure/directory-structure.selectors';
import { DirectoryColumnTypesEntryRemoteDto } from 'src/generated/signalR/directory-column-types-entry-remote-dto';
import { DirectoryEntryRemoteDto, OrganisationEntryRemoteDto } from 'src/generated/swagger';

export class DirectoryHelperSelectors {
   @Selector([
      DirectoryHelperState.additionalEmailColumns,
      DirectoryStructureSelectors.getOrganisationDataEntryForDirectoryColumn,
      DirectoryHelperState.getSelectedEntryForSearch,
      DirectoryHelperSelectors.getField,
      DirectoryHelperSelectors.getOrgFieldData,
   ])
   public static emailsFromCustomColumns(
      emailCustomColumns: DirectoryColumnTypesEntryRemoteDto[],
      getOrganisationDataEntryForDirectoryColumn: (
         selectedDirectoryEntry: OrganisationEntryRemoteDto,
         organisationUnitNumber: string
      ) => OrganisationEntryRemoteDto,
      selectedDirectoryEntry: DirectoryEntryRemoteDto,
      getField: (field: string, orgEntry: OrganisationEntryRemoteDto) => string,
      getOrgFieldData: (
         columnName: string
      ) => {
         orgId: string;
         fieldName: string;
      }
   ): string[] {
      return emailCustomColumns
         .map((column) => getOrgFieldData(column.fldColumnName))
         .filter((orgField) => !_.isNil(orgField))
         .map((orgField) => getField(orgField.fieldName, getOrganisationDataEntryForDirectoryColumn(selectedDirectoryEntry, orgField.orgId)))
         .filter((field) => !_.isNil(field));
   }

   @Selector()
   public static getField() {
      return (field: string, orgEntry: OrganisationEntryRemoteDto) => {
         let fieldValue = '';
         if (orgEntry) {
            if (field.startsWith('orgfeld')) {
               const orgfeldId = field.substring(7);
               fieldValue = orgEntry[`field${orgfeldId}`].value ?? '';
            } else {
               fieldValue = typeof orgEntry[field] === 'string' ? orgEntry[field] : orgEntry[field].value;
            }
         }
         return _.isEmpty(fieldValue) ? null : fieldValue;
      };
   }

   @Selector()
   public static getOrgFieldData() {
      return (columnName: string) => {
         const orgFieldRegex: RegExp = new RegExp(/TBL_ORG(\d{2})\.FLD_([^%]+)/gi);
         const match = orgFieldRegex.exec(columnName);
         if (!match) {
            return null;
         }
         return { orgId: match[1], fieldName: match[2].toLowerCase() };
      };
   }
}
